import React from "react";

import "./TrendStatusArrows.scss";

const ARROW_ICON = {
  "up-right": "fa-arrow-up",
  "down-right": "fa-arrow-down"
};

export const TrendStatusArrow = ({ direction, color }) => {
  const iconClass = ARROW_ICON[direction];

  return (
    <i
      className={`fas ${iconClass} trend-status-arrow trend-status-arrow--${direction}`}
      style={{ color }}
      aria-hidden
    />
  );
};

export const TrendStatusArrows = ({ arrows }) => (
  <span className="inline-flex items-center trend-status-arrows">
    {arrows.map(({ direction, color }, index) => (
      <TrendStatusArrow
        key={`${direction}-${index}`}
        direction={direction}
        color={color}
      />
    ))}
  </span>
);
